import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import HeroCarousel from '../Common/HeroCarousel';
import ministry1Image from '../../Assets/Ministry 1.png';
import ministry2Image from '../../Assets/Ministry 2.png';
import ministry3Image from '../../Assets/Ministry 3.png';
import ministry4Image from '../../Assets/Ministry 4.png';

const Ministries = () => {
  const navigate = useNavigate();

  const ministries = [
    {
      id: 1,
      title: 'Worship & Creative arts Ministries',
      image: ministry3Image,
      borderColor: 'border-blue-500',
      route: '/ministries/worship-creative-arts'
    },
    {
      id: 2,
      title: 'Life-stage Ministries',
      image: ministry1Image,
      borderColor: 'border-purple-500',
      route: '/ministries/life-stage'
    },
    {
      id: 3,
      title: 'Outreach & Service Ministries',
      image: ministry2Image,
      borderColor: 'border-blue-400',
      route: '/ministries/outreach-service'
    },
    {
      id: 4,
      title: 'Support & Growth Ministries',
      image: ministry4Image,
      borderColor: 'border-blue-300',
      route: '/ministries/support-growth'
    }
  ];

  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <HeroCarousel 
        title="Ministries"
        subtitle="Discover how you can grow, serve, and connect through our specialized ministries"
        height="h-96"
        contentPosition="bottom"
      />

      {/* Ministries Grid Section */}
      <div className="bg-white py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto ">
            {ministries.map((ministry) => (
              <button 
                key={ministry.id}
                onClick={() => navigate(ministry.route)}
                className={`relative rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer border-4 ${ministry.borderColor}`}
              >
                <div className="relative h-90">
                  <img 
                    src={ministry.image} 
                    alt={ministry.title} 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                    <h3 className="text-white text-2xl font-bold text-center px-6 font-sf-pro">
                      {ministry.title}
                    </h3>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Ministries;
